import { Fragment } from "@wordpress/element";
import { getBlockDefaultClassName } from '@wordpress/blocks';
import { PanelBody, ToggleControl  } from "@wordpress/components";
import { InnerBlocks, InspectorControls } from '@wordpress/block-editor';
import { __ } from "@wordpress/i18n";

const ThreeColumns = {
  title: __('Three column content'),
  description: __('Three column content block for the ABS theme'),
  icon: 'media-spreadsheet',
  attributes: {
    inverseStyling : {
      default: false,
      type:   'boolean',
    },
  },
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes, isSelected }) {
    const { inverseStyling } = attributes;
    const toggleInverseStyling = () => {
      setAttributes( { inverseStyling: !inverseStyling } );
    };
    const ALLOWED_BLOCKS = [ 'core/image', 'core/paragraph', 'core/list', 'core/button' ];
    const MY_TEMPLATE = [
      [ 'core/heading', { placeholder: __('Section Title'), level: 2 } ],
      [ 'core/columns', { className: 'row' }, [
        [ 'core/column', { className: 'col-sm-4' }, [
            [ 'core/image', {} ],
            [ 'core/heading', { placeholder: __('Column Title'), level: 3 } ],
            [ 'core/paragraph', { placeholder: __('Column Content'), fontSize: 'small' } ],
          ]
        ],
        [ 'core/column', { className: 'col-sm-4' }, [
            [ 'core/image', {} ],
            [ 'core/heading', { placeholder: __('Column Title'), level: 3 } ],
            [ 'core/paragraph', { placeholder: __('Column Content'), fontSize: 'small' } ],
          ]
        ],
        [ 'core/column', { className: 'col-sm-4' }, [
            [ 'core/image', {} ],
            [ 'core/heading', { placeholder: __('Column Title'), level: 3 } ],
            [ 'core/paragraph', { placeholder: __('Column Content'), fontSize: 'small' } ],
          ]
        ]
      ]],
    ];

    if (inverseStyling) {
      className += ' inverted';
    }

    return (
      <Fragment>
        <div className={className}>
          <div className="container">
            <InnerBlocks
              template={ MY_TEMPLATE }
              allowedBlocks={ ALLOWED_BLOCKS }
            />
          </div>
        </div>

      { isSelected &&
      <InspectorControls>
        <PanelBody title={ __('Block Style') }>
          <ToggleControl
            label={ __('Invert colors') }
            help={ inverseStyling ? __('Inverted display') : __('Default display') }
            checked={ !! inverseStyling }
            onChange={ toggleInverseStyling }
          />
        </PanelBody>
      </InspectorControls>
      }
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    let className = getBlockDefaultClassName( 'abs/content-three-column-block' );
    const { inverseStyling } = attributes;

    if (inverseStyling) {
      className += ' inverted';
    }

    return (
      <div className={className}>
        <div className="container">
          <InnerBlocks.Content />
        </div>
      </div>
    );
  },
};

export default ThreeColumns;
